<template>
  <div>
    Loading...
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import { checkAuth } from '../firestoreConnection.js';

export default {
  name: 'auth-check',
  mounted() {
    checkAuth(this)
      .then(function() {
        this.$router.push('/lists');
      }.bind(this))
      .catch(function() {
        this.$router.push('/login');
      }.bind(this));
  }
};
</script>

<style scoped>
</style>
